import { excluded } from 'vee-validate/dist/rules'

export default {
  ...excluded,
  params: [
    {
      name: 'excludedValues',
      default: []
    }
  ],
  /**
  * Validates a given value(string) against a array of strings.
  *
  * @param {string} value - The string value to be validated.
  * @param {Object} params - An object containing an array of strings.
  * @param {Array} params.excludedValues - An array of strings which the param value should not match.
  * @returns {boolean} - Returns true if the provided `value` is not in `params.excludedValues` list or is null/undefined/empty, otherwise returns false.
  */
  validate (value, params) {
    if (value === null || value === undefined || value === '') {
      return true
    }

    const excludedValue = params.excludedValues.filter(excludedValue => excludedValue.toUpperCase().trim() === value.toUpperCase().trim())
    return excludedValue.length === 0
  }
}
